"use strict";
// IF A NEW FACET IS ADDED IT SHOULD INCLUDE THE ALLOWED VALUES IN ALL_HARDCODED_FACETS
// All possible facets are listed here
// useHardcodedValues is just a way to test if the search provider doesn't return the correct values
// onlyNonEmptyResults is to ensure just facets that return values are going to be displayed
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTRUCTOR_COLLECTION_ALLOWED_FACETS = exports.ALL_HARDCODED_FACETS = exports.getCategorySpecificFacets = exports.PRINTS_FACETS_ORDER_AND_IS_OPEN = exports.ORIGINALS_FACETS_ORDER_AND_IS_OPEN = exports.PRINTS_ALLOWED_FACETS = exports.ORIGINALS_ALLOWED_FACETS = exports.ALLOWED_SIZE_VALUES = exports.PRICE_ATTRIBUTES_LIST = exports.ALLOWED_PRICE_VALUES = exports.ALL_MATERIALS = exports.ALLOWED_PRINT_MATERIAL_VALUES = exports.ALL_MEDIUMS = exports.ALLOWED_INSTALLATION_MATERIALS_VALUES = exports.ALLOWED_PRINTMAKING_MATERIALS_VALUES = exports.ALLOWED_COLLAGE_MATERIALS_VALUES = exports.ALLOWED_SCULPTURE_MATERIALS_VALUES = exports.ALLOWED_MIXED_MEDIA_MATERIALS_VALUES = exports.ALLOWED_DRAWINGS_MATERIALS_VALUES = exports.ALLOWED_DIGITAL_MATERIALS_VALUES = exports.ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES = exports.ALLOWED_PAINTINGS_MATERIALS_VALUES = exports.ALLOWED_INSTALLATION_MEDIUMS_VALUES = exports.ALLOWED_PRINTMAKING_MEDIUMS_VALUES = exports.ALLOWED_COLLAGE_MEDIUMS_VALUES = exports.ALLOWED_SCULPTURE_MEDIUMS_VALUES = exports.ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES = exports.ALLOWED_DRAWINGS_MEDIUMS_VALUES = exports.ALLOWED_DIGITAL_MEDIUMS_VALUES = exports.ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES = exports.ALLOWED_PAINTINGS_MEDIUMS_VALUES = exports.ALLOWED_ORIENTATION_VALUES = exports.ALLOWED_COLORS = exports.ALLOWED_STYLE_VALUES = exports.ALLOWED_SUBJECT_VALUES = exports.SORT_BY_AND_ORDER = exports.SORT_VALUES = exports.ALLOWED_ARTWORK_CATEGORY_FACET_VALUES = exports.ALLOWED_CATEGORY_VALUES = exports.UNIQUE_DESTINATION_ZONES = exports.OTHER_FACETS = exports.FACET_NAMES = exports.BOOLEAN_FACET_NAMES = exports.PRINT_FACET_NAMES = exports.COMMON_FACET_NAMES = exports.CATEGORY_VALUES_NAMES = void 0;
const iso2GeoZones_1 = __importDefault(require("../../constants/iso2GeoZones"));
/* Helper Functions */
// Filter to remove price sort options if there is any other filter selected (that is a facet and not helpers like page, has_prints)
const onFilterSortOptions = ({ selectedFacets, currentOptions }) => {
    const filtersToRemove = ['query', 'hitsPerPage', 'page', 'sort', 'has_prints'];
    const selectedFiltersFiltered = Object.fromEntries(Object.entries(selectedFacets).filter(([key]) => !filtersToRemove.includes(key)));
    return currentOptions.filter(({ value }) => {
        const noFiltersSelected = Object.values(selectedFiltersFiltered).every((selectedFacetValue) => Array.isArray(selectedFacetValue) && selectedFacetValue.length === 0);
        if (noFiltersSelected) {
            return true;
        }
        return ![exports.SORT_VALUES.PRICE_LOW_TO_HIGH, exports.SORT_VALUES.PRICE_HIGH_TO_LOW].includes(value);
    });
};
/* =================================================================================================================== */
/* Common Values */
exports.CATEGORY_VALUES_NAMES = {
    ALL: 'all',
    PAINTINGS: 'paintings',
    PHOTOGRAPHY: 'photography',
    DIGITAL: 'digital',
    DRAWINGS: 'drawings',
    MIXED_MEDIA: 'mixed-media',
    SCULPTURE: 'sculpture',
    COLLAGE: 'collage',
    PRINTMAKING: 'printmaking',
    INSTALLATION: 'installation',
};
exports.COMMON_FACET_NAMES = {
    SORT: 'sort',
    ARTWORK_CATEGORY: 'artwork_category',
    CATEGORY: 'category',
    STYLES: 'styles',
    SUBJECT: 'subject',
    MEDIUMS: 'mediums',
    SIZE: 'size_bin',
    PRICE: 'geo_prices',
    ARTIST_COUNTRY: 'country',
    ORIENTATION: 'orientation',
    MATERIALS: 'materials',
    FEATURED_IN: 'artist_recognition',
    COLOR: 'color',
    INSTALLATION_TYPE: 'installation_type',
};
exports.PRINT_FACET_NAMES = {
    PRINT_MATERIAL: 'print_materials',
    PRINT_SIZE: 'print_size_bins',
    PRINT_ORIENTATION: 'print_orientations',
    PRINT_PRICE: 'print_all_prices',
};
exports.BOOLEAN_FACET_NAMES = {
    OUTDOOR_SAFE: 'is_outdoor_safe',
    READY_TO_HANG: 'is_ready_to_hang',
    FRAME: 'is_framed',
};
exports.FACET_NAMES = Object.assign(Object.assign(Object.assign({}, exports.COMMON_FACET_NAMES), exports.PRINT_FACET_NAMES), exports.BOOLEAN_FACET_NAMES);
exports.OTHER_FACETS = {
    WIDTH: 'width',
    HEIGHT: 'height',
    GROUP_ID: 'group_id',
    CREATED_AT: 'created_at',
    ARTWORK_CATEGORY: 'artwork_category',
    COLLECTION_ID: 'collection_id',
};
exports.UNIQUE_DESTINATION_ZONES = Array.from(new Set(Object.values(iso2GeoZones_1.default)));
exports.ALLOWED_CATEGORY_VALUES = [
    { label: 'All', value: 'all' },
    { label: 'Painting', value: 'paintings' },
    { label: 'Photography', value: 'photography' },
    { label: 'Sculpture', value: 'sculpture' },
    { label: 'Drawing', value: 'drawings' },
    { label: 'Mixed Media', value: 'mixed-media' },
    { label: 'Printmaking', value: 'printmaking' },
    { label: 'Collage', value: 'collage' },
    { label: 'Digital', value: 'digital' },
    { label: 'Installation', value: 'installation' },
];
exports.ALLOWED_ARTWORK_CATEGORY_FACET_VALUES = [
    { label: 'Painting', value: 'painting' },
    { label: 'Photography', value: 'photography' },
    { label: 'Sculpture', value: 'sculpture' },
    { label: 'Drawing', value: 'drawing' },
    { label: 'Mixed Media', value: 'mixed media' },
    { label: 'Printmaking', value: 'printmaking' },
    { label: 'Collage', value: 'collage' },
    { label: 'Digital', value: 'digital' },
    { label: 'Installation', value: 'installation' },
];
/* =================================================================================================================== */
/* Sort Values */
exports.SORT_VALUES = {
    RECOMMENDED: 'default',
    NEW_TO_OLD: 'newest',
    PRICE_LOW_TO_HIGH: 'price-low',
    PRICE_HIGH_TO_LOW: 'price-high',
    OLD_TO_NEW: 'oldest',
};
exports.SORT_BY_AND_ORDER = {
    [exports.SORT_VALUES.RECOMMENDED]: {
        sortBy: 'relevance',
        sortOrder: 'descending',
    },
    [exports.SORT_VALUES.NEW_TO_OLD]: {
        sortBy: 'newest',
        sortOrder: 'descending',
    },
    [exports.SORT_VALUES.PRICE_LOW_TO_HIGH]: {
        sortBy: 'price-low',
        sortOrder: 'ascending',
    },
    [exports.SORT_VALUES.PRICE_HIGH_TO_LOW]: {
        sortBy: 'price-high',
        sortOrder: 'descending',
    },
    [exports.SORT_VALUES.OLD_TO_NEW]: {
        sortBy: 'newest',
        sortOrder: 'ascending',
    },
};
/* =================================================================================================================== */
/* Shared Allowed Values */
exports.ALLOWED_SUBJECT_VALUES = [
    { label: 'Abstract', value: 'abstract' },
    { label: 'Animal', value: 'animal' },
    { label: 'Architecture', value: 'architecture' },
    { label: 'Beach', value: 'beach' },
    { label: 'Boat', value: 'boat' },
    { label: 'Body', value: 'body' },
    { label: 'Botanic', value: 'botanic' },
    { label: 'Calligraphy', value: 'calligraphy' },
    { label: 'Car', value: 'car' },
    { label: 'Cartoon', value: 'cartoon' },
    { label: 'Cats', value: 'cats' },
    { label: 'Children', value: 'children' },
    { label: 'Christmas', value: 'christmas' },
    { label: 'Cinema', value: 'cinema' },
    { label: 'Cities', value: 'cities' },
    { label: 'Classical Mythology', value: 'classical mythology' },
    { label: 'Comics', value: 'comics' },
    { label: 'Dogs', value: 'dogs' },
    { label: 'Erotic', value: 'erotic' },
    { label: 'Family', value: 'family' },
    { label: 'Famous', value: 'famous' },
    { label: 'Fantasy', value: 'fantasy' },
    { label: 'Fashion', value: 'fashion' },
    { label: 'Floral', value: 'floral' },
    { label: 'Food & Drink', value: 'food & drink' },
    { label: 'Garden', value: 'garden' },
    { label: 'Geometric', value: 'geometric' },
    { label: 'Graffiti', value: 'graffiti' },
    { label: 'Health & Beauty', value: 'health & beauty' },
    { label: 'Holiday', value: 'holiday' },
    { label: 'Home', value: 'home' },
    { label: 'Horse', value: 'horse' },
    { label: 'Humor', value: 'humor' },
    { label: 'Jesus', value: 'jesus' },
    { label: 'Landscape', value: 'landscape' },
    { label: 'Language', value: 'language' },
    { label: 'Light', value: 'light' },
    { label: 'Love', value: 'love' },
    { label: 'Men', value: 'men' },
    { label: 'Mountain', value: 'mountain' },
    { label: 'Music', value: 'music' },
    { label: 'Nature', value: 'nature' },
    { label: 'Nude', value: 'nude' },
    { label: 'Ocean', value: 'ocean' },
    { label: 'Outer Space', value: 'outer space' },
    { label: 'Patterns', value: 'patterns' },
    { label: 'People', value: 'people' },
    { label: 'Performing Arts', value: 'performing arts' },
    { label: 'Politics', value: 'politics' },
    { label: 'Pop Culture/Celebrity', value: 'pop culture/celebrity' },
    { label: 'Religion', value: 'religion' },
    { label: 'Rural life', value: 'rural life' },
    { label: 'Science/Technology', value: 'science/technology' },
    { label: 'Seascape', value: 'seascape' },
    { label: 'Sports', value: 'sports' },
    { label: 'Still Life', value: 'still life' },
    { label: 'Sunrise', value: 'sunrise' },
    { label: 'Sunset', value: 'sunset' },
    { label: 'Time', value: 'time' },
    { label: 'Transportation', value: 'transportation' },
    { label: 'Travel', value: 'travel' },
    { label: 'Typography', value: 'typography' },
    { label: 'Water', value: 'water' },
    { label: 'Wildlife', value: 'wildlife' },
    { label: 'Women', value: 'women' },
];
exports.ALLOWED_STYLE_VALUES = [
    { label: 'Abstract', value: 'abstract' },
    { label: 'Abstract Expressionism', value: 'abstract expressionism' },
    { label: 'Algorithmic', value: 'algorithmic' },
    { label: 'Antique', value: 'antique' },
    { label: 'Art Deco', value: 'art deco' },
    { label: 'Art Nouveau', value: 'art nouveau' },
    { label: 'Artificial Intelligence', value: 'artificial intelligence' },
    { label: 'Baroque', value: 'baroque' },
    { label: 'Bauhaus', value: 'bauhaus' },
    { label: 'Black & White', value: 'black & white' },
    { label: 'Classicism', value: 'classicism' },
    { label: 'Color Field Painting', value: 'color field painting' },
    { label: 'Conceptual', value: 'conceptual' },
    { label: 'Contemporary', value: 'contemporary' },
    { label: 'Cubism', value: 'cubism' },
    { label: 'Dada', value: 'dada' },
    { label: 'Digital Art', value: 'digital art' },
    { label: 'Documentary', value: 'documentary' },
    { label: 'Expressionism', value: 'expressionism' },
    { label: 'Fauvism', value: 'fauvism' },
    { label: 'Figurative', value: 'figurative' },
    { label: 'Folk', value: 'folk' },
    { label: 'Fractal', value: 'fractal' },
    { label: 'Futurism', value: 'futurism' },
    { label: 'Generative', value: 'generative' },
    { label: 'Geometric', value: 'geometric' },
    { label: 'Glitch', value: 'glitch' },
    { label: 'Graphics and Animation', value: 'graphics and animation' },
    { label: 'Illustration', value: 'illustration' },
    { label: 'Impressionism', value: 'impressionism' },
    { label: 'Installation Art', value: 'installation art' },
    { label: 'Kinetic', value: 'kinetic' },
    { label: 'Minimalism', value: 'minimalism' },
    { label: 'Modernism', value: 'modernism' },
    { label: 'Mural', value: 'mural' },
    { label: 'Neo-Impressionism', value: 'neo-impressionism' },
    { label: 'Neoclassicism', value: 'neoclassicism' },
    { label: 'Op Art', value: 'op art' },
    { label: 'Painterly Abstraction', value: 'painterly abstraction' },
    { label: 'Photorealism', value: 'photorealism' },
    { label: 'Pop Art', value: 'pop art' },
    { label: 'Portraiture', value: 'portraiture' },
    { label: 'Post-Impressionism', value: 'post-impressionism' },
    { label: 'Realism', value: 'realism' },
    { label: 'Renaissance', value: 'renaissance' },
    { label: 'Rococo', value: 'rococo' },
    { label: 'Romanticism', value: 'romanticism' },
    { label: 'Street Art', value: 'street art' },
    { label: 'Surrealism', value: 'surrealism' },
    { label: 'Symbolism', value: 'symbolism' },
    { label: 'Vintage', value: 'vintage' },
];
const ALLOWED_COUNTRIES = [
    { label: 'United States', value: 'united states' },
    { label: 'United Kingdom', value: 'united kingdom' },
    { label: 'Germany', value: 'germany' },
    { label: 'Italy', value: 'italy' },
    { label: 'France', value: 'france' },
    { label: 'Canada', value: 'canada' },
    { label: 'Spain', value: 'spain' },
    { label: 'Netherlands', value: 'netherlands' },
    { label: 'India', value: 'india' },
    { label: 'Australia', value: 'australia' },
    { label: 'Russia', value: 'russia' },
    { label: 'Poland', value: 'poland' },
    { label: 'Israel', value: 'israel' },
    { label: 'Argentina', value: 'argentina' },
    { label: 'Hungary', value: 'hungary' },
    { label: 'Belgium', value: 'belgium' },
    { label: 'Switzerland', value: 'switzerland' },
    { label: 'Austria', value: 'austria' },
    { label: 'Turkey', value: 'turkey' },
    { label: 'Brazil', value: 'brazil' },
    { label: 'Romania', value: 'romania' },
    { label: 'Portugal', value: 'portugal' },
    { label: 'China', value: 'china' },
    { label: 'Serbia', value: 'serbia' },
    { label: 'Greece', value: 'greece' },
    { label: 'Bulgaria', value: 'bulgaria' },
    { label: 'Ukraine', value: 'ukraine' },
    { label: 'Ireland', value: 'ireland' },
    { label: 'Czech Republic', value: 'czech republic' },
    { label: 'Mexico', value: 'mexico' },
    { label: 'Japan', value: 'japan' },
    { label: 'Sweden', value: 'sweden' },
    { label: 'Chile', value: 'chile' },
    { label: 'Norway', value: 'norway' },
    { label: 'Vietnam', value: 'vietnam' },
    { label: 'South Korea', value: 'south korea' },
    { label: 'Denmark', value: 'denmark' },
    { label: 'Croatia', value: 'croatia' },
    { label: 'South Africa', value: 'south africa' },
    { label: 'Lithuania', value: 'lithuania' },
    { label: 'Latvia', value: 'latvia' },
    { label: 'Georgia', value: 'georgia' },
    { label: 'Slovenia', value: 'slovenia' },
    { label: 'Indonesia', value: 'indonesia' },
    { label: 'Colombia', value: 'colombia' },
    { label: 'Finland', value: 'finland' },
    { label: 'Slovakia', value: 'slovakia' },
    { label: 'New Zealand', value: 'new zealand' },
    { label: 'Estonia', value: 'estonia' },
    { label: 'Thailand', value: 'thailand' },
    { label: 'Hong Kong', value: 'hong kong' },
    { label: 'North Macedonia', value: 'north macedonia' },
    { label: 'Kazakhstan', value: 'kazakhstan' },
    { label: 'Belarus', value: 'belarus' },
    { label: 'Egypt', value: 'egypt' },
    { label: 'Peru', value: 'peru' },
    { label: 'Saint Martin', value: 'saint martin' },
    { label: 'Venezuela', value: 'venezuela' },
    { label: 'Malaysia', value: 'malaysia' },
    { label: 'Uruguay', value: 'uruguay' },
    { label: 'Singapore', value: 'singapore' },
    { label: 'Cyprus', value: 'cyprus' },
    { label: 'Armenia', value: 'armenia' },
    { label: 'Morocco', value: 'morocco' },
    { label: 'Nigeria', value: 'nigeria' },
    { label: 'United Arab Emirates', value: 'united arab emirates' },
    { label: 'Samoa', value: 'samoa' },
    { label: 'U.S. Minor Outlying Islands', value: 'u.s. minor outlying islands' },
    { label: 'Azerbaijan', value: 'azerbaijan' },
    { label: 'Iceland', value: 'iceland' },
    { label: 'Moldova', value: 'moldova' },
    { label: 'Taiwan', value: 'taiwan' },
    { label: 'Puerto Rico', value: 'puerto rico' },
    { label: 'Lebanon', value: 'lebanon' },
    { label: 'Ecuador', value: 'ecuador' },
    { label: 'Philippines', value: 'philippines' },
    { label: 'Pakistan', value: 'pakistan' },
    { label: 'Malta', value: 'malta' },
    { label: 'Trinidad And Tobago', value: 'trinidad and tobago' },
    { label: 'Kosovo', value: 'kosovo' },
    { label: 'Costa Rica', value: 'costa rica' },
    { label: 'Montenegro', value: 'montenegro' },
    { label: 'Bahrain', value: 'bahrain' },
    { label: 'Albania', value: 'albania' },
    { label: 'Bosnia And Herzegovina', value: 'bosnia and herzegovina' },
    { label: 'Ghana', value: 'ghana' },
    { label: 'Luxembourg', value: 'luxembourg' },
    { label: 'Saudi Arabia', value: 'saudi arabia' },
    { label: 'Sri Lanka', value: 'sri lanka' },
    { label: 'Uzbekistan', value: 'uzbekistan' },
    { label: 'Dominican Republic', value: 'dominican republic' },
    { label: 'Jordan', value: 'jordan' },
    { label: 'Kenya', value: 'kenya' },
    { label: 'Mauritius', value: 'mauritius' },
    { label: 'Bangladesh', value: 'bangladesh' },
    { label: 'Barbados', value: 'barbados' },
    { label: 'Panama', value: 'panama' },
    { label: 'Algeria', value: 'algeria' },
    { label: 'Monaco', value: 'monaco' },
    { label: 'Martinique', value: 'martinique' },
];
exports.ALLOWED_COLORS = [
    { label: '#00374B', value: '#00374b' },
    { label: '#004B63', value: '#004b63' },
    { label: '#00728B', value: '#00728b' },
    { label: '#038DBB', value: '#038dbb' },
    { label: '#00A2D8', value: '#00a2d8' },
    { label: '#00C7FF', value: '#00c7ff' },
    { label: '#55D6FE', value: '#55d6fe' },
    { label: '#90E4FE', value: '#90e4fe' },
    { label: '#CAF2FE', value: '#caf2fe' },
    { label: '#001E5A', value: '#001e5a' },
    { label: '#013078', value: '#013078' },
    { label: '#0142A6', value: '#0142a6' },
    { label: '#0057D5', value: '#0057d5' },
    { label: '#0460FF', value: '#0460ff' },
    { label: '#3689FF', value: '#3689ff' },
    { label: '#75A7FE', value: '#75a7fe' },
    { label: '#AAC4FD', value: '#aac4fd' },
    { label: '#D4E4FB', value: '#d4e4fb' },
    { label: '#12053D', value: '#12053d' },
    { label: '#180B51', value: '#180b51' },
    { label: '#2C1378', value: '#2c1378' },
    { label: '#391B95', value: '#391b95' },
    { label: '#4A24B7', value: '#4a24b7' },
    { label: '#5A32EB', value: '#5a32eb' },
    { label: '#854FFB', value: '#854ffb' },
    { label: '#B28CFB', value: '#b28cfb' },
    { label: '#DACAFB', value: '#dacafb' },
    { label: '#2E0843', value: '#2e0843' },
    { label: '#450F5D', value: '#450f5d' },
    { label: '#63167E', value: '#63167e' },
    { label: '#77239D', value: '#77239d' },
    { label: '#9A2ABA', value: '#9a2aba' },
    { label: '#BC37F2', value: '#bc37f2' },
    { label: '#D456FF', value: '#d456ff' },
    { label: '#E395FB', value: '#e395fb' },
    { label: '#F1C9FE', value: '#f1c9fe' },
    { label: '#3F051B', value: '#3f051b' },
    { label: '#551126', value: '#551126' },
    { label: '#7A193C', value: '#7a193c' },
    { label: '#97274F', value: '#97274f' },
    { label: '#BB2A61', value: '#bb2a61' },
    { label: '#E73A79', value: '#e73a79' },
    { label: '#EF6F9F', value: '#ef6f9f' },
    { label: '#F6A3BF', value: '#f6a3bf' },
    { label: '#F8D4E0', value: '#f8d4e0' },
    { label: '#5B0601', value: '#5b0601' },
    { label: '#830D00', value: '#830d00' },
    { label: '#B51902', value: '#b51902' },
    { label: '#E12300', value: '#e12300' },
    { label: '#FE4310', value: '#fe4310' },
    { label: '#FE634D', value: '#fe634d' },
    { label: '#FF8C85', value: '#ff8c85' },
    { label: '#FCB5AF', value: '#fcb5af' },
    { label: '#FFD8D9', value: '#ffd8d9' },
    { label: '#591C00', value: '#591c00' },
    { label: '#792A01', value: '#792a01' },
    { label: '#AC3F00', value: '#ac3f00' },
    { label: '#DC5100', value: '#dc5100' },
    { label: '#FD6B00', value: '#fd6b00' },
    { label: '#FF8448', value: '#ff8448' },
    { label: '#FFA47D', value: '#ffa47d' },
    { label: '#FFC4A8', value: '#ffc4a8' },
    { label: '#FEE2D6', value: '#fee2d6' },
    { label: '#583400', value: '#583400' },
    { label: '#794803', value: '#794803' },
    { label: '#AB6702', value: '#ab6702' },
    { label: '#D38306', value: '#d38306' },
    { label: '#FFAA00', value: '#ffaa00' },
    { label: '#FFB23C', value: '#ffb23c' },
    { label: '#FFC878', value: '#ffc878' },
    { label: '#FFD8A8', value: '#ffd8a8' },
    { label: '#FFEBD3', value: '#ffebd3' },
    { label: '#553D00', value: '#553d00' },
    { label: '#765700', value: '#765700' },
    { label: '#A57C00', value: '#a57c00' },
    { label: '#D5A209', value: '#d5a209' },
    { label: '#FFC501', value: '#ffc501' },
    { label: '#FFC940', value: '#ffc940' },
    { label: '#FED374', value: '#fed374' },
    { label: '#FDE5A7', value: '#fde5a7' },
    { label: '#FEF3D5', value: '#fef3d5' },
    { label: '#666002', value: '#666002' },
    { label: '#888901', value: '#888901' },
    { label: '#C2BD00', value: '#c2bd00' },
    { label: '#F4ED01', value: '#f4ed01' },
    { label: '#FDFB44', value: '#fdfb44' },
    { label: '#FBF968', value: '#fbf968' },
    { label: '#FDFA91', value: '#fdfa91' },
    { label: '#FFFCB5', value: '#fffcb5' },
    { label: '#FFFCDB', value: '#fffcdb' },
    { label: '#505600', value: '#505600' },
    { label: '#717507', value: '#717507' },
    { label: '#9CA50C', value: '#9ca50c' },
    { label: '#C6CE16', value: '#c6ce16' },
    { label: '#D8EB37', value: '#d8eb37' },
    { label: '#E4EF62', value: '#e4ef62' },
    { label: '#EBF38E', value: '#ebf38e' },
    { label: '#F1F7B7', value: '#f1f7b7' },
    { label: '#F9F9DD', value: '#f9f9dd' },
    { label: '#283E0F', value: '#283e0f' },
    { label: '#3B571C', value: '#3b571c' },
    { label: '#4C7C28', value: '#4c7c28' },
    { label: '#649C31', value: '#649c31' },
    { label: '#75BA43', value: '#75ba43' },
    { label: '#97D45F', value: '#97d45f' },
    { label: '#B0DC87', value: '#b0dc87' },
    { label: '#CDE9B8', value: '#cde9b8' },
    { label: '#E2EBDA', value: '#e2ebda' },
];
const ALLOWED_SORT_VALUES = [
    {
        label: 'Recommended',
        value: exports.SORT_VALUES.RECOMMENDED,
    },
    {
        label: 'Date Listed: New to Old',
        value: exports.SORT_VALUES.NEW_TO_OLD,
    },
    {
        label: 'Price: Low to High',
        value: exports.SORT_VALUES.PRICE_LOW_TO_HIGH,
    },
    {
        label: 'Price: High to Low',
        value: exports.SORT_VALUES.PRICE_HIGH_TO_LOW,
    },
];
exports.ALLOWED_ORIENTATION_VALUES = [
    { label: 'Horizontal', value: 'horizontal' },
    { label: 'Vertical', value: 'vertical' },
    { label: 'Square', value: 'square' },
];
exports.ALLOWED_PAINTINGS_MEDIUMS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Airbrush', value: 'airbrush' },
    { label: 'Casein', value: 'casein' },
    { label: 'Enamel', value: 'enamel' },
    { label: 'Encaustic', value: 'encaustic' },
    { label: 'Gesso', value: 'gesso' },
    { label: 'Glazing', value: 'glazing' },
    { label: 'Gold Leaf', value: 'gold leaf' },
    { label: 'Gouache', value: 'gouache' },
    { label: 'Household Paint', value: 'household paint' },
    { label: 'Ink', value: 'ink' },
    { label: 'Oil', value: 'oil' },
    { label: 'Oil Stick', value: 'oil stick' },
    { label: 'Pastel', value: 'pastel' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Resin', value: 'resin' },
    { label: 'Spray Paint', value: 'spray paint' },
    { label: 'Tempera', value: 'tempera' },
    { label: 'Watercolor', value: 'watercolor' },
];
exports.ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES = [
    { label: 'Black & White', value: 'black & white' },
    { label: 'C-type', value: 'c-type' },
    { label: 'Color', value: 'color' },
    { label: 'Digital', value: 'digital' },
    { label: 'Dye Transfer', value: 'dye transfer' },
    { label: 'Full spectrum', value: 'full spectrum' },
    { label: 'Gelatin', value: 'gelatin' },
    { label: 'Giclée', value: 'giclée' },
    { label: 'Ink', value: 'ink' },
    { label: 'Lenticular', value: 'lenticular' },
    { label: 'Manipulated', value: 'manipulated' },
    { label: 'Photogram', value: 'photogram' },
    { label: 'Pinhole', value: 'pinhole' },
    { label: 'Platinum', value: 'platinum' },
    { label: 'Polaroid', value: 'polaroid' },
];
exports.ALLOWED_DIGITAL_MEDIUMS_VALUES = [
    { label: 'Artificial Intelligence', value: 'artificial intelligence' },
    { label: 'Digital', value: 'digital' },
    { label: 'Moving Images', value: 'moving images' },
];
exports.ALLOWED_DRAWINGS_MEDIUMS_VALUES = [
    { label: 'Ballpoint Pen', value: 'ballpoint pen' },
    { label: 'Chalk', value: 'chalk' },
    { label: 'Charcoal', value: 'charcoal' },
    { label: 'Colored Pencil', value: 'colored pencil' },
    { label: 'Conte', value: 'conte' },
    { label: 'Crayon', value: 'crayon' },
    { label: 'Digital', value: 'digital' },
    { label: 'Graphite', value: 'graphite' },
    { label: 'Ink', value: 'ink' },
    { label: 'Marker', value: 'marker' },
    { label: 'Pastel', value: 'pastel' },
    { label: 'Pencil', value: 'pencil' },
    { label: 'Silverpoint', value: 'silverpoint' },
];
exports.ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES = [
    { label: '3D Sculpting', value: '3d sculpting' },
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Airbrush', value: 'airbrush' },
    { label: 'Algorithmic Art', value: 'algorithmic art' },
    { label: 'Aquatint', value: 'aquatint' },
    { label: 'Ballpoint Pen', value: 'ballpoint pen' },
    { label: 'Beading', value: 'beading' },
    { label: 'Bronze', value: 'bronze' },
    { label: 'C-type', value: 'c-type' },
    { label: 'Chalk', value: 'chalk' },
    { label: 'Charcoal', value: 'charcoal' },
    { label: 'Clay', value: 'clay' },
    { label: 'Conte', value: 'conte' },
    { label: 'Crayon', value: 'crayon' },
    { label: 'Decoupage', value: 'decoupage' },
    { label: 'Digital', value: 'digital' },
    { label: 'Drypoint', value: 'drypoint' },
    { label: 'Enamel', value: 'enamel' },
    { label: 'Engraving', value: 'engraving' },
    { label: 'Etching', value: 'etching' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Fiber', value: 'fiber' },
    { label: 'Fiberglass', value: 'fiberglass' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Fractal', value: 'fractal' },
    { label: 'Gelatin', value: 'gelatin' },
    { label: 'Gesso', value: 'gesso' },
    { label: 'Giclée', value: 'giclée' },
    { label: 'Glass', value: 'glass' },
    { label: 'Glitter', value: 'glitter' },
    { label: 'Gold Leaf', value: 'gold leaf' },
    { label: 'Gouache', value: 'gouache' },
    { label: 'Graphite', value: 'graphite' },
    { label: 'Ink', value: 'ink' },
    { label: 'Interactive', value: 'interactive' },
    { label: 'Latex', value: 'latex' },
    { label: 'Leather', value: 'leather' },
    { label: 'LED', value: 'led' },
    { label: 'Lenticular', value: 'lenticular' },
    { label: 'Lights', value: 'lights' },
    { label: 'Linocuts', value: 'linocuts' },
    { label: 'Lithograph', value: 'lithograph' },
    { label: 'Manipulated', value: 'manipulated' },
    { label: 'Marker', value: 'marker' },
    { label: 'Mezzotint', value: 'mezzotint' },
    { label: 'Mezzotint', value: 'mezzotint' },
    { label: 'Monotype', value: 'monotype' },
    { label: 'Mosaic', value: 'mosaic' },
    { label: 'Neon', value: 'neon' },
    { label: 'Oil', value: 'oil' },
    { label: 'Paint', value: 'paint' },
    { label: 'Paper', value: 'paper' },
    { label: 'Paper mache', value: 'paper mache' },
    { label: 'Pastel', value: 'pastel' },
    { label: 'Pen and Ink', value: 'pen and ink' },
    { label: 'Pencil', value: 'pencil' },
    { label: 'Photogram', value: 'photogram' },
    { label: 'Photography', value: 'photography' },
    { label: 'Pinhole', value: 'pinhole' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Platinum', value: 'platinum' },
    { label: 'Polaroid', value: 'polaroid' },
    { label: 'Precious Materials', value: 'precious materials' },
    { label: 'Resin', value: 'resin' },
    { label: 'Robotics', value: 'robotics' },
    { label: 'Screenprinting', value: 'screenprinting' },
    { label: 'Silverpoint', value: 'silverpoint' },
    { label: 'Spray Paint', value: 'spray paint' },
    { label: 'Stencil', value: 'stencil' },
    { label: 'Tempera', value: 'tempera' },
    { label: 'Textile', value: 'textile' },
    { label: 'Thread', value: 'thread' },
    { label: 'Vector', value: 'vector' },
    { label: 'Video', value: 'video' },
    { label: 'Watercolor', value: 'watercolor' },
    { label: 'Wax', value: 'wax' },
    { label: 'Woodcut', value: 'woodcut' },
];
exports.ALLOWED_SCULPTURE_MEDIUMS_VALUES = [
    { label: '3D Printing', value: '3d printing' },
    { label: '3D Sculpting', value: '3d sculpting' },
    { label: 'Assemblage', value: 'assemblage' },
    { label: 'Carving', value: 'carving' },
    { label: 'Casting', value: 'casting' },
    { label: 'Modeling', value: 'modeling' },
    { label: 'Relief', value: 'relief' },
    { label: 'Weaving', value: 'weaving' },
];
exports.ALLOWED_COLLAGE_MEDIUMS_VALUES = [
    { label: 'Paper', value: 'paper' },
    { label: 'Paint', value: 'paint' },
    { label: 'Photo', value: 'photo' },
    { label: 'Ink', value: 'ink' },
    { label: 'Digital', value: 'digital' },
    { label: 'Wood', value: 'wood' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Metal', value: 'metal' },
    { label: 'Manipulated', value: 'manipulated' },
    { label: 'Textile', value: 'textile' },
    { label: 'Glass', value: 'glass' },
    { label: 'Wax', value: 'wax' },
    { label: 'Decoupage', value: 'decoupage' },
];
exports.ALLOWED_PRINTMAKING_MEDIUMS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Aquatint', value: 'aquatint' },
    { label: 'Digital', value: 'digital' },
    { label: 'Drypoint', value: 'drypoint' },
    { label: 'Dye Transfer', value: 'dye transfer' },
    { label: 'Engraving', value: 'engraving' },
    { label: 'Etching', value: 'etching' },
    { label: 'Ink', value: 'ink' },
    { label: 'Linocuts', value: 'linocuts' },
    { label: 'Lithograph', value: 'lithograph' },
    { label: 'Manipulated', value: 'manipulated' },
    { label: 'Mezzotint', value: 'mezzotint' },
    { label: 'Monotype', value: 'monotype' },
    { label: 'Oil', value: 'oil' },
    { label: 'Screenprinting', value: 'screenprinting' },
    { label: 'Stencil', value: 'stencil' },
    { label: 'Woodcut', value: 'woodcut' },
];
exports.ALLOWED_INSTALLATION_MEDIUMS_VALUES = [
    { label: 'Artificial Intelligence', value: 'artificial intelligence' },
    { label: 'Ceramic', value: 'ceramic' },
    { label: 'Clay', value: 'clay' },
    { label: 'Digital', value: 'digital' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Fiberglass', value: 'fiberglass' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Glass', value: 'glass' },
    { label: 'Ink', value: 'ink' },
    { label: 'Interactive', value: 'interactive' },
    { label: 'Kinetic', value: 'kinetic' },
    { label: 'LED', value: 'led' },
    { label: 'Lights', value: 'lights' },
    { label: 'Metal', value: 'metal' },
    { label: 'Mixed Media', value: 'mixed media' },
    { label: 'Mosaic', value: 'mosaic' },
    { label: 'Neon', value: 'neon' },
    { label: 'Oil', value: 'oil' },
    { label: 'Paint', value: 'paint' },
    { label: 'Paper', value: 'paper' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Resin', value: 'resin' },
    { label: 'Sound', value: 'sound' },
    { label: 'Steel', value: 'steel' },
    { label: 'Stone', value: 'stone' },
    { label: 'Textile', value: 'textile' },
    { label: 'Video', value: 'video' },
    { label: 'Wood', value: 'wood' },
];
exports.ALLOWED_PAINTINGS_MATERIALS_VALUES = [
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Canvas', value: 'canvas' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Ceramic', value: 'ceramic' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Glass', value: 'glass' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Linen', value: 'linen' },
    { label: 'Linen', value: 'linen' },
    { label: 'MDF', value: 'mdf' },
    { label: 'Metal', value: 'metal' },
    { label: 'Paper', value: 'paper' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Silk', value: 'silk' },
    { label: 'Wood', value: 'wood' },
    { label: 'Other', value: 'other' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
];
exports.ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Aluminum Dibond', value: 'aluminum dibond' },
    { label: 'Canvas', value: 'canvas' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Glass', value: 'glass' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Linen', value: 'linen' },
    { label: 'Linen', value: 'linen' },
    { label: 'Metal', value: 'metal' },
    { label: 'Paper', value: 'paper' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Silk', value: 'silk' },
    { label: 'Wood', value: 'wood' },
    { label: 'Other', value: 'other' },
];
exports.ALLOWED_DIGITAL_MATERIALS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Aluminum Dibond', value: 'aluminum dibond' },
    { label: 'Canvas', value: 'canvas' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Glass', value: 'glass' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Linen', value: 'linen' },
    { label: 'Linen', value: 'linen' },
    { label: 'Metal', value: 'metal' },
    { label: 'Paper', value: 'paper' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Silk', value: 'silk' },
    { label: 'Wood', value: 'wood' },
    { label: 'Other', value: 'other' },
];
exports.ALLOWED_DRAWINGS_MATERIALS_VALUES = [
    { label: 'Canvas', value: 'canvas' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Glass', value: 'glass' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Linen', value: 'linen' },
    { label: 'Linen', value: 'linen' },
    { label: 'Metal', value: 'metal' },
    { label: 'Paper', value: 'paper' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Silk', value: 'silk' },
    { label: 'Wood', value: 'wood' },
    { label: 'Other', value: 'other' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
];
exports.ALLOWED_MIXED_MEDIA_MATERIALS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Airbrush', value: 'airbrush' },
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Aluminum Dibond', value: 'aluminum dibond' },
    { label: 'Baryta', value: 'baryta' },
    { label: 'Bronze', value: 'bronze' },
    { label: 'Canvas', value: 'canvas' },
    { label: 'Carbon Fiber', value: 'carbon fiber' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Ceramic', value: 'ceramic' },
    { label: 'Clay', value: 'clay' },
    { label: 'Concrete', value: 'concrete' },
    { label: 'Copper', value: 'copper' },
    { label: 'Cotton Paper', value: 'cotton paper' },
    { label: 'Digital', value: 'digital' },
    { label: 'Enamel', value: 'enamel' },
    { label: 'Environmental', value: 'environmental' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Fiber', value: 'fiber' },
    { label: 'Fiberglass', value: 'fiberglass' },
    { label: 'Fine Art Paper', value: 'fine art paper' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Glass', value: 'glass' },
    { label: 'Glue', value: 'glue' },
    { label: 'Gold', value: 'gold' },
    { label: 'Gold Leaf', value: 'gold leaf' },
    { label: 'Granite', value: 'granite' },
    { label: 'Graphite', value: 'graphite' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Interactive', value: 'interactive' },
    { label: 'Iron', value: 'iron' },
    { label: 'Leather', value: 'leather' },
    { label: 'LED', value: 'led' },
    { label: 'Lights', value: 'lights' },
    { label: 'Linen', value: 'linen' },
    { label: 'Marble', value: 'marble' },
    { label: 'Masonite', value: 'masonite' },
    { label: 'MDF', value: 'mdf' },
    { label: 'Metal', value: 'metal' },
    { label: 'Mosaic', value: 'mosaic' },
    { label: 'Neon', value: 'neon' },
    { label: 'Panel', value: 'panel' },
    { label: 'Paper mache', value: 'paper mache' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Porcelain', value: 'porcelain' },
    { label: 'Pottery', value: 'pottery' },
    { label: 'Resin', value: 'resin' },
    { label: 'Rubber', value: 'rubber' },
    { label: 'Sand', value: 'sand' },
    { label: 'Silk', value: 'silk' },
    { label: 'Stainless Steel', value: 'stainless steel' },
    { label: 'Steel', value: 'steel' },
    { label: 'Stone', value: 'stone' },
    { label: 'Textile', value: 'textile' },
    { label: 'Thread', value: 'thread' },
    { label: 'Timber', value: 'timber' },
    { label: 'Varnish', value: 'varnish' },
    { label: 'Wax', value: 'wax' },
    { label: 'Wood', value: 'wood' },
    { label: 'Wool', value: 'wool' },
    { label: 'Other', value: 'other' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
];
exports.ALLOWED_SCULPTURE_MATERIALS_VALUES = [
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Bronze', value: 'bronze' },
    { label: 'Carbon Fiber', value: 'carbon fiber' },
    { label: 'Ceramic', value: 'ceramic' },
    { label: 'Clay', value: 'clay' },
    { label: 'Concrete', value: 'concrete' },
    { label: 'Copper', value: 'copper' },
    { label: 'Cork', value: 'cork' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Cotton Paper', value: 'cotton paper' },
    { label: 'Enamel', value: 'enamel' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Fiber', value: 'fiber' },
    { label: 'Fiberglass', value: 'fiberglass' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Glass', value: 'glass' },
    { label: 'Gold', value: 'gold' },
    { label: 'Granite', value: 'granite' },
    { label: 'Graphite', value: 'graphite' },
    { label: 'Hard Foam', value: 'hard foam' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Iron', value: 'iron' },
    { label: 'Leather', value: 'leather' },
    { label: 'LED', value: 'led' },
    { label: 'Marble', value: 'marble' },
    { label: 'Masonite', value: 'masonite' },
    { label: 'MDF', value: 'mdf' },
    { label: 'Metal', value: 'metal' },
    { label: 'Mosaic', value: 'mosaic' },
    { label: 'Neon', value: 'neon' },
    { label: 'Panel', value: 'panel' },
    { label: 'Paper', value: 'paper' },
    { label: 'Paper mache', value: 'paper mache' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Porcelain', value: 'porcelain' },
    { label: 'Pottery', value: 'pottery' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
    { label: 'Resin', value: 'resin' },
    { label: 'Rubber', value: 'rubber' },
    { label: 'Sand', value: 'sand' },
    { label: 'Silicone', value: 'silicone' },
    { label: 'Silk', value: 'silk' },
    { label: 'Silver', value: 'silver' },
    { label: 'Stainless Steel', value: 'stainless steel' },
    { label: 'Steel', value: 'steel' },
    { label: 'Stone', value: 'stone' },
    { label: 'Textile', value: 'textile' },
    { label: 'Thread', value: 'thread' },
    { label: 'Timber', value: 'timber' },
    { label: 'Wax', value: 'wax' },
    { label: 'Wood', value: 'wood' },
    { label: 'Wool', value: 'wool' },
    { label: 'Yarn', value: 'yarn' },
];
exports.ALLOWED_COLLAGE_MATERIALS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Airbrush', value: 'airbrush' },
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Aluminum Dibond', value: 'aluminum dibond' },
    { label: 'Baryta', value: 'baryta' },
    { label: 'Bronze', value: 'bronze' },
    { label: 'Canvas', value: 'canvas' },
    { label: 'Carbon Fiber', value: 'carbon fiber' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Ceramic', value: 'ceramic' },
    { label: 'Clay', value: 'clay' },
    { label: 'Concrete', value: 'concrete' },
    { label: 'Copper', value: 'copper' },
    { label: 'Cotton Paper', value: 'cotton paper' },
    { label: 'Digital', value: 'digital' },
    { label: 'Enamel', value: 'enamel' },
    { label: 'Environmental', value: 'environmental' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Fiber', value: 'fiber' },
    { label: 'Fiberglass', value: 'fiberglass' },
    { label: 'Fine Art Paper', value: 'fine art paper' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Glass', value: 'glass' },
    { label: 'Glue', value: 'glue' },
    { label: 'Gold', value: 'gold' },
    { label: 'Gold Leaf', value: 'gold leaf' },
    { label: 'Granite', value: 'granite' },
    { label: 'Graphite', value: 'graphite' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Interactive', value: 'interactive' },
    { label: 'Iron', value: 'iron' },
    { label: 'Leather', value: 'leather' },
    { label: 'LED', value: 'led' },
    { label: 'Lights', value: 'lights' },
    { label: 'Linen', value: 'linen' },
    { label: 'Marble', value: 'marble' },
    { label: 'Masonite', value: 'masonite' },
    { label: 'MDF', value: 'mdf' },
    { label: 'Metal', value: 'metal' },
    { label: 'Mosaic', value: 'mosaic' },
    { label: 'Neon', value: 'neon' },
    { label: 'Other', value: 'other' },
    { label: 'Panel', value: 'panel' },
    { label: 'Paper mache', value: 'paper mache' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Porcelain', value: 'porcelain' },
    { label: 'Pottery', value: 'pottery' },
    { label: 'Resin', value: 'resin' },
    { label: 'Rubber', value: 'rubber' },
    { label: 'Sand', value: 'sand' },
    { label: 'Silk', value: 'silk' },
    {
        label: 'Soft (Yarn Cotton Fabric)',
        value: 'soft (yarn cotton fabric)',
    },
    { label: 'Stainless Steel', value: 'stainless steel' },
    { label: 'Steel', value: 'steel' },
    { label: 'Stone', value: 'stone' },
    { label: 'Textile', value: 'textile' },
    { label: 'Thread', value: 'thread' },
    { label: 'Timber', value: 'timber' },
    { label: 'Varnish', value: 'varnish' },
    { label: 'Wax', value: 'wax' },
    { label: 'Wood', value: 'wood' },
    { label: 'Wool', value: 'wool' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
];
exports.ALLOWED_PRINTMAKING_MATERIALS_VALUES = [
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Canvas', value: 'canvas' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Glass', value: 'glass' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Linen', value: 'linen' },
    { label: 'Metal', value: 'metal' },
    { label: 'Paper', value: 'paper' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Silk', value: 'silk' },
    { label: 'Wood', value: 'wood' },
    { label: 'Other', value: 'other' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
];
exports.ALLOWED_INSTALLATION_MATERIALS_VALUES = [
    { label: 'Aluminum', value: 'aluminum' },
    { label: 'Bronze', value: 'bronze' },
    { label: 'Carbon Fiber', value: 'carbon fiber' },
    { label: 'Corrugated Cardboard', value: 'corrugated cardboard' },
    { label: 'Ceramic', value: 'ceramic' },
    { label: 'Clay', value: 'clay' },
    { label: 'Concrete', value: 'concrete' },
    { label: 'Copper', value: 'copper' },
    { label: 'Cotton Paper', value: 'cotton paper' },
    { label: 'Enamel', value: 'enamel' },
    { label: 'Fabric', value: 'fabric' },
    { label: 'Fiber', value: 'fiber' },
    { label: 'Fiberglass', value: 'fiberglass' },
    { label: 'Found Objects', value: 'found objects' },
    { label: 'Glass', value: 'glass' },
    { label: 'Gold', value: 'gold' },
    { label: 'Granite', value: 'granite' },
    { label: 'Graphite', value: 'graphite' },
    { label: 'Hardboard', value: 'hardboard' },
    { label: 'Iron', value: 'iron' },
    { label: 'Leather', value: 'leather' },
    { label: 'LED', value: 'led' },
    { label: 'Marble', value: 'marble' },
    { label: 'Masonite', value: 'masonite' },
    { label: 'MDF', value: 'mdf' },
    { label: 'Metal', value: 'metal' },
    { label: 'Mosaic', value: 'mosaic' },
    { label: 'Neon', value: 'neon' },
    { label: 'Panel', value: 'panel' },
    { label: 'Paper', value: 'paper' },
    { label: 'Paper mache', value: 'paper mache' },
    { label: 'Plaster', value: 'plaster' },
    { label: 'Plastic', value: 'plastic' },
    { label: 'Plexiglass', value: 'plexiglass' },
    { label: 'Plywood', value: 'plywood' },
    { label: 'Porcelain', value: 'porcelain' },
    { label: 'Pottery', value: 'pottery' },
    { label: 'Resin', value: 'resin' },
    { label: 'Rubber', value: 'rubber' },
    { label: 'Sand', value: 'sand' },
    { label: 'Silk', value: 'silk' },
    { label: 'Silver', value: 'silver' },
    { label: 'Stainless Steel', value: 'stainless steel' },
    { label: 'Steel', value: 'steel' },
    { label: 'Stone', value: 'stone' },
    { label: 'Textile', value: 'textile' },
    { label: 'Thread', value: 'thread' },
    { label: 'Timber', value: 'timber' },
    { label: 'Wax', value: 'wax' },
    { label: 'Wood', value: 'wood' },
    { label: 'Wool', value: 'wool' },
    { label: 'Other', value: 'other' },
    { label: 'Pressed Cardboard', value: 'pressed cardboard' },
];
const ALLOWED_FEATURED_IN_VALUES = [
    { label: 'Saatchi Art Catalog', value: 'saatchi art catalog' },
    { label: 'The Other Art Fair', value: 'the other art fair' },
    { label: 'One To Watch', value: 'one to watch' },
    { label: 'Invest In Art', value: 'invest in art' },
    { label: 'Rising Stars', value: 'rising stars' },
    { label: 'Inside The Studio', value: 'inside the studio' },
];
const ALLOWED_INSTALLATION_TYPE_VALUES = [
    { label: 'Free-Standing', value: 'free_standing' },
    { label: 'Wall-Mounted', value: 'wall_mounted' },
];
exports.ALL_MEDIUMS = [
    ...exports.ALLOWED_PAINTINGS_MEDIUMS_VALUES,
    ...exports.ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES,
    ...exports.ALLOWED_DIGITAL_MEDIUMS_VALUES,
    ...exports.ALLOWED_DRAWINGS_MEDIUMS_VALUES,
    ...exports.ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES,
    ...exports.ALLOWED_SCULPTURE_MEDIUMS_VALUES,
    ...exports.ALLOWED_COLLAGE_MEDIUMS_VALUES,
    ...exports.ALLOWED_PRINTMAKING_MEDIUMS_VALUES,
    ...exports.ALLOWED_INSTALLATION_MEDIUMS_VALUES,
];
exports.ALLOWED_PRINT_MATERIAL_VALUES = [
    { label: 'Canvas', value: 'canvas' },
    { label: 'Metal', value: 'metal' },
    { label: 'Acrylic', value: 'acrylic' },
    { label: 'Fine Art Paper', value: 'rag' },
    { label: 'Photo Paper', value: 'photo' },
];
exports.ALL_MATERIALS = [
    ...exports.ALLOWED_PAINTINGS_MATERIALS_VALUES,
    ...exports.ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES,
    ...exports.ALLOWED_DIGITAL_MATERIALS_VALUES,
    ...exports.ALLOWED_DRAWINGS_MATERIALS_VALUES,
    ...exports.ALLOWED_MIXED_MEDIA_MATERIALS_VALUES,
    ...exports.ALLOWED_SCULPTURE_MATERIALS_VALUES,
    ...exports.ALLOWED_COLLAGE_MATERIALS_VALUES,
    ...exports.ALLOWED_PRINTMAKING_MATERIALS_VALUES,
    ...exports.ALLOWED_INSTALLATION_MATERIALS_VALUES,
];
/* =================================================================================================================== */
// Used only for URL logics to know possible values
exports.ALLOWED_PRICE_VALUES = [
    { label: '0-500', value: '0-500' },
    { label: '500-1000', value: '500-1000' },
    { label: '1000-2000', value: '1000-2000' },
    { label: '2000-5000', value: '2000-5000' },
    { label: '5000-10000', value: '5000-10000' },
    { label: '10000-300000', value: '10000-300000' },
];
exports.PRICE_ATTRIBUTES_LIST = [
    {
        label: 'Under $500',
        presetMin: 0,
        presetMax: 500,
        format: 'under',
    },
    {
        label: '$500 - $1,000',
        presetMin: 500,
        presetMax: 1000,
        format: 'divider',
    },
    {
        label: '$1,000 - $2,000',
        presetMin: 1000,
        presetMax: 2000,
        format: 'divider',
    },
    {
        label: '$2,000 - $5,000',
        presetMin: 2000,
        presetMax: 5000,
        format: 'divider',
    },
    {
        label: '$5,000 - $10,000',
        presetMin: 5000,
        presetMax: 10000,
        format: 'divider',
    },
    {
        label: 'Over $10,000',
        presetMin: 10000,
        presetMax: 300000,
        format: 'over',
    },
];
const ALLOWED_PRINT_PRICE_VALUES = [
    { label: '0-200', value: '0-200' },
    { label: '200-300', value: '200-300' },
    { label: '300-400', value: '300-400' },
    { label: '400-500', value: '400-500' },
    { label: '500-300000', value: '500-300000' },
];
const PRINT_PRICE_ATTRIBUTES_LIST = [
    {
        label: 'Under $200',
        presetMin: 0,
        presetMax: 200,
        format: 'under',
    },
    {
        label: '$200 - $300',
        presetMin: 200,
        presetMax: 300,
        format: 'divider',
    },
    {
        label: '$300 - $400',
        presetMin: 300,
        presetMax: 400,
        format: 'divider',
    },
    {
        label: '$400 - $500',
        presetMin: 400,
        presetMax: 500,
        format: 'divider',
    },
    {
        label: 'Over $500',
        presetMin: 500,
        presetMax: 300000,
        format: 'over',
    },
];
exports.ALLOWED_SIZE_VALUES = [
    { label: 'small', value: 'small' },
    { label: 'medium', value: 'medium' },
    { label: 'large', value: 'large' },
    { label: 'oversized', value: 'oversized' },
];
const ALLOWED_BOOLEAN_VALUES = [
    { label: 'true', value: 'True' },
    { label: 'false', value: 'False' },
];
/* =================================================================================================================== */
// we will have to send the selectedFacets to the function that filter this (to filter the mediums and materials by the category selected)
// key is the facetName
exports.ORIGINALS_ALLOWED_FACETS = {
    [exports.FACET_NAMES.SORT]: {
        allowedValues: ALLOWED_SORT_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: false,
        title: 'Sort',
        inputType: 'sort',
        extraData: {
            defaultValue: 'Recommended',
        },
    },
    [exports.FACET_NAMES.CATEGORY]: {
        allowedValues: exports.ALLOWED_CATEGORY_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: false,
        title: 'Category',
        inputType: 'radio',
        extraData: {
            defaultValue: 'All',
        },
    },
    [exports.FACET_NAMES.STYLES]: {
        allowedValues: exports.ALLOWED_STYLE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Style',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.SUBJECT]: {
        allowedValues: exports.ALLOWED_SUBJECT_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Subject',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALL_MEDIUMS,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
        extraData: {
            hasSpecialRule: true,
        },
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALL_MATERIALS,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
        extraData: {
            hasSpecialRule: true,
        },
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_PAINTINGS_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_PAINTINGS_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_DIGITAL_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_DIGITAL_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_DRAWINGS_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_DRAWINGS_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_MIXED_MEDIA_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_SCULPTURE_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Method',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_SCULPTURE_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.INSTALLATION_TYPE}`]: {
        allowedValues: ALLOWED_INSTALLATION_TYPE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: false,
        title: 'Installation Type',
        inputType: 'radio',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_COLLAGE_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_COLLAGE_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_PRINTMAKING_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_PRINTMAKING_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_INSTALLATION_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_INSTALLATION_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.OUTDOOR_SAFE}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Outdoor Safe',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.INSTALLATION_TYPE}`]: {
        allowedValues: ALLOWED_INSTALLATION_TYPE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: false,
        title: 'Installation Type',
        inputType: 'radio',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.OUTDOOR_SAFE}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Outdoor Safe',
        inputType: 'toggle',
    },
    [exports.FACET_NAMES.PRICE]: {
        allowedValues: exports.ALLOWED_PRICE_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: true,
        title: 'Price',
        inputType: 'price',
        extraData: {
            priceOptions: exports.PRICE_ATTRIBUTES_LIST,
        },
    },
    [exports.FACET_NAMES.SIZE]: {
        allowedValues: exports.ALLOWED_SIZE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Size',
        inputType: 'size',
    },
    [exports.FACET_NAMES.ORIENTATION]: {
        allowedValues: exports.ALLOWED_ORIENTATION_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Orientation',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.ARTIST_COUNTRY]: {
        allowedValues: ALLOWED_COUNTRIES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Artist Country',
        inputType: 'checkbox',
        extraData: {
            searchFacetTextPlaceholder: 'Search Country',
        },
    },
    [exports.FACET_NAMES.FEATURED_IN]: {
        allowedValues: ALLOWED_FEATURED_IN_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Featured In',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
};
exports.PRINTS_ALLOWED_FACETS = {
    [exports.FACET_NAMES.SORT]: {
        allowedValues: ALLOWED_SORT_VALUES.filter(({ value }) => [exports.SORT_VALUES.RECOMMENDED, exports.SORT_VALUES.NEW_TO_OLD].includes(value)),
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: false,
        title: 'Sort',
        inputType: 'sort',
        extraData: {
            defaultValue: 'Recommended',
            onFilterSortOptions,
        },
    },
    // V2
    // [FACET_NAMES.FRAME]: {
    //   allowedValues: ALLOWED_BOOLEAN_VALUES,
    //   onlyNonEmptyResults: false,
    //   useHardcodedValues: false,
    //   useProviderValues: false,
    //   isOpen: true,
    //   isToggle: true,
    //   title: 'Framed',
    //   inputType: 'toggle',
    // },
    [exports.FACET_NAMES.PRINT_SIZE]: {
        allowedValues: exports.ALLOWED_SIZE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Size',
        inputType: 'size',
        extraData: {
            isPrintFacet: true,
        },
    },
    [exports.FACET_NAMES.PRINT_ORIENTATION]: {
        allowedValues: exports.ALLOWED_ORIENTATION_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Orientation',
        inputType: 'checkbox',
    },
    // [FACET_NAMES.PRINT_PRICE]: {
    //   allowedValues: ALLOWED_PRINT_PRICE_VALUES,
    //   onlyNonEmptyResults: false,
    //   useHardcodedValues: true,
    //   useProviderValues: false,
    //   isOpen: true,
    //   title: 'Price',
    //   inputType: 'price',
    //   extraData: {
    //     priceOptions: PRINT_PRICE_ATTRIBUTES_LIST,
    //   },
    // },
    [exports.FACET_NAMES.STYLES]: {
        allowedValues: exports.ALLOWED_STYLE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Style',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.SUBJECT]: {
        allowedValues: exports.ALLOWED_SUBJECT_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Subject',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.CATEGORY]: {
        allowedValues: exports.ALLOWED_CATEGORY_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: false,
        title: 'Original Medium',
        inputType: 'radio',
        extraData: {
            defaultValue: 'All',
        },
    },
    [exports.FACET_NAMES.COLOR]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [exports.FACET_NAMES.ARTIST_COUNTRY]: {
        allowedValues: ALLOWED_COUNTRIES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Artist Country',
        inputType: 'checkbox',
        extraData: {
            searchFacetTextPlaceholder: 'Search Country',
        },
    },
    [exports.FACET_NAMES.FEATURED_IN]: {
        allowedValues: ALLOWED_FEATURED_IN_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Featured In',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.PRINT_MATERIAL]: {
        allowedValues: exports.ALLOWED_PRINT_MATERIAL_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: true,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
};
/* =================================================================================================================== */
/* Order and is open logics */
// Paintings, Drawings, Printmaking, Digital, Mixed Media, Collage
const basicOrder = [
    exports.FACET_NAMES.SORT,
    exports.FACET_NAMES.CATEGORY,
    exports.FACET_NAMES.ARTWORK_CATEGORY,
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
    exports.FACET_NAMES.MEDIUMS,
    exports.FACET_NAMES.SIZE,
    exports.FACET_NAMES.PRICE,
    exports.FACET_NAMES.ARTIST_COUNTRY,
    exports.FACET_NAMES.ORIENTATION,
    exports.FACET_NAMES.MATERIALS,
    exports.FACET_NAMES.FEATURED_IN,
    exports.FACET_NAMES.COLOR,
    exports.FACET_NAMES.READY_TO_HANG,
    exports.FACET_NAMES.FRAME,
];
const basicIsOpen = [
    exports.FACET_NAMES.CATEGORY,
    exports.FACET_NAMES.ARTWORK_CATEGORY,
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
    exports.FACET_NAMES.MEDIUMS,
    exports.FACET_NAMES.SIZE,
    exports.FACET_NAMES.PRICE,
];
// Sculpture, Installation
const sculptureOrder = [
    exports.FACET_NAMES.SORT,
    exports.FACET_NAMES.CATEGORY,
    exports.FACET_NAMES.ARTWORK_CATEGORY,
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
    exports.FACET_NAMES.MEDIUMS,
    exports.FACET_NAMES.SIZE,
    exports.FACET_NAMES.PRICE,
    exports.FACET_NAMES.ARTIST_COUNTRY,
    exports.FACET_NAMES.MATERIALS,
    exports.FACET_NAMES.FEATURED_IN,
    exports.FACET_NAMES.OUTDOOR_SAFE,
    exports.FACET_NAMES.INSTALLATION_TYPE,
    exports.FACET_NAMES.ORIENTATION,
];
const sculptureIsOpen = [
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
    exports.FACET_NAMES.MEDIUMS,
    exports.FACET_NAMES.SIZE,
    exports.FACET_NAMES.PRICE,
];
const installationIsOpen = [
    exports.FACET_NAMES.CATEGORY,
    exports.FACET_NAMES.ARTWORK_CATEGORY,
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
    exports.FACET_NAMES.MEDIUMS,
    exports.FACET_NAMES.SIZE,
    exports.FACET_NAMES.PRICE,
];
// Prints
const printsOrder = [
    exports.FACET_NAMES.SORT,
    exports.FACET_NAMES.PRINT_MATERIAL,
    exports.FACET_NAMES.PRINT_SIZE,
    exports.FACET_NAMES.FRAME,
    exports.FACET_NAMES.PRINT_ORIENTATION,
    exports.FACET_NAMES.PRINT_PRICE,
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
    exports.FACET_NAMES.CATEGORY,
    exports.FACET_NAMES.ARTWORK_CATEGORY,
    exports.FACET_NAMES.COLOR,
    exports.FACET_NAMES.ARTIST_COUNTRY,
    exports.FACET_NAMES.FEATURED_IN,
];
const printsIsOpen = [
    exports.FACET_NAMES.PRINT_MATERIAL,
    exports.FACET_NAMES.PRINT_SIZE,
    exports.FACET_NAMES.FRAME,
    exports.FACET_NAMES.PRINT_ORIENTATION,
    exports.FACET_NAMES.PRINT_PRICE,
    exports.FACET_NAMES.STYLES,
    exports.FACET_NAMES.SUBJECT,
];
// change this to check if it is expanded or collapsed too
exports.ORIGINALS_FACETS_ORDER_AND_IS_OPEN = {
    [exports.CATEGORY_VALUES_NAMES.ALL]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.PAINTINGS]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.DRAWINGS]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.PRINTMAKING]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.DIGITAL]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.COLLAGE]: {
        order: basicOrder,
        isOpen: basicIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.SCULPTURE]: {
        order: sculptureOrder,
        isOpen: sculptureIsOpen,
    },
    [exports.CATEGORY_VALUES_NAMES.INSTALLATION]: {
        order: sculptureOrder,
        isOpen: installationIsOpen,
    },
};
exports.PRINTS_FACETS_ORDER_AND_IS_OPEN = {
    default: {
        order: printsOrder,
        isOpen: printsIsOpen,
    },
};
const getCategorySpecificFacets = (category) => {
    if (!category)
        return [];
    const categoryPrefix = `${category}__`;
    return Object.keys(exports.ORIGINALS_ALLOWED_FACETS)
        .filter((key) => key.startsWith(categoryPrefix))
        .map((key) => key.replace(categoryPrefix, ''));
};
exports.getCategorySpecificFacets = getCategorySpecificFacets;
/* =================================================================================================================== */
exports.ALL_HARDCODED_FACETS = {
    [exports.FACET_NAMES.ARTWORK_CATEGORY]: exports.ALLOWED_ARTWORK_CATEGORY_FACET_VALUES,
    [exports.FACET_NAMES.CATEGORY]: exports.ALLOWED_CATEGORY_VALUES,
    [exports.FACET_NAMES.SUBJECT]: exports.ALLOWED_SUBJECT_VALUES,
    [exports.FACET_NAMES.STYLES]: exports.ALLOWED_STYLE_VALUES,
    [exports.FACET_NAMES.ARTIST_COUNTRY]: ALLOWED_COUNTRIES,
    [exports.FACET_NAMES.COLOR]: exports.ALLOWED_COLORS,
    [exports.FACET_NAMES.ORIENTATION]: exports.ALLOWED_ORIENTATION_VALUES,
    [exports.FACET_NAMES.FEATURED_IN]: ALLOWED_FEATURED_IN_VALUES,
    [exports.FACET_NAMES.INSTALLATION_TYPE]: ALLOWED_INSTALLATION_TYPE_VALUES,
    [exports.FACET_NAMES.PRICE]: exports.ALLOWED_PRICE_VALUES,
    [exports.FACET_NAMES.SIZE]: exports.ALLOWED_SIZE_VALUES,
    [exports.FACET_NAMES.MEDIUMS]: exports.ALL_MEDIUMS,
    [exports.FACET_NAMES.MATERIALS]: exports.ALL_MATERIALS,
    [exports.FACET_NAMES.PRINT_MATERIAL]: exports.ALLOWED_PRINT_MATERIAL_VALUES,
    [exports.FACET_NAMES.FRAME]: ALLOWED_BOOLEAN_VALUES,
    [exports.FACET_NAMES.READY_TO_HANG]: ALLOWED_BOOLEAN_VALUES,
    [exports.FACET_NAMES.OUTDOOR_SAFE]: ALLOWED_BOOLEAN_VALUES,
    [exports.FACET_NAMES.PRINT_SIZE]: exports.ALLOWED_SIZE_VALUES,
    [exports.FACET_NAMES.PRINT_ORIENTATION]: exports.ALLOWED_ORIENTATION_VALUES,
    [exports.FACET_NAMES.PRINT_PRICE]: exports.ALLOWED_PRICE_VALUES,
};
/* =================================================================================================================== */
// New Arrivals allowed facets, the only difference for now is that categories are not hardcoded and should get from `artwork_category`
exports.CONSTRUCTOR_COLLECTION_ALLOWED_FACETS = {
    [exports.FACET_NAMES.SORT]: {
        allowedValues: ALLOWED_SORT_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: false,
        title: 'Sort',
        inputType: 'sort',
        extraData: {
            defaultValue: 'Recommended',
        },
    },
    [exports.FACET_NAMES.CATEGORY]: {
        allowedValues: exports.ALLOWED_CATEGORY_VALUES,
        sourceFacetName: exports.FACET_NAMES.ARTWORK_CATEGORY,
        // "All" is always shown even though the provider never returns an `all` bucket.
        alwaysIncludedValues: [{ label: 'All', value: exports.CATEGORY_VALUES_NAMES.ALL }],
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: false,
        title: 'Category',
        inputType: 'radio',
        extraData: {
            defaultValue: 'All',
            // "All" shows selected whenever no category is chosen, so it is highlighted on
            // both /new-arrivals and /new-arrivals/all.
            selectDefaultWhenEmpty: true,
        },
    },
    [exports.FACET_NAMES.STYLES]: {
        allowedValues: exports.ALLOWED_STYLE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Style',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.SUBJECT]: {
        allowedValues: exports.ALLOWED_SUBJECT_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Subject',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALL_MEDIUMS,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
        extraData: {
            hasSpecialRule: true,
        },
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALL_MATERIALS,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
        extraData: {
            hasSpecialRule: true,
        },
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_PAINTINGS_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_PAINTINGS_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_DIGITAL_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_DIGITAL_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_DRAWINGS_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_DRAWINGS_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_MIXED_MEDIA_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_SCULPTURE_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Method',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_SCULPTURE_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.INSTALLATION_TYPE}`]: {
        allowedValues: ALLOWED_INSTALLATION_TYPE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: false,
        title: 'Installation Type',
        inputType: 'radio',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_COLLAGE_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_COLLAGE_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_PRINTMAKING_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_PRINTMAKING_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.MEDIUMS}`]: {
        allowedValues: exports.ALLOWED_INSTALLATION_MEDIUMS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Medium',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.MATERIALS}`]: {
        allowedValues: exports.ALLOWED_INSTALLATION_MATERIALS_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Material',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.OUTDOOR_SAFE}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Outdoor Safe',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.INSTALLATION}__${exports.FACET_NAMES.INSTALLATION_TYPE}`]: {
        allowedValues: ALLOWED_INSTALLATION_TYPE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: false,
        title: 'Installation Type',
        inputType: 'radio',
    },
    [`${exports.CATEGORY_VALUES_NAMES.SCULPTURE}__${exports.FACET_NAMES.OUTDOOR_SAFE}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Outdoor Safe',
        inputType: 'toggle',
    },
    [exports.FACET_NAMES.PRICE]: {
        allowedValues: exports.ALLOWED_PRICE_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: true,
        useProviderValues: false,
        isOpen: true,
        title: 'Price',
        inputType: 'price',
        extraData: {
            priceOptions: exports.PRICE_ATTRIBUTES_LIST,
        },
    },
    [exports.FACET_NAMES.SIZE]: {
        allowedValues: exports.ALLOWED_SIZE_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Size',
        inputType: 'size',
    },
    [exports.FACET_NAMES.ORIENTATION]: {
        allowedValues: exports.ALLOWED_ORIENTATION_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Orientation',
        inputType: 'checkbox',
    },
    [exports.FACET_NAMES.ARTIST_COUNTRY]: {
        allowedValues: ALLOWED_COUNTRIES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Artist Country',
        inputType: 'checkbox',
        extraData: {
            searchFacetTextPlaceholder: 'Search Country',
        },
    },
    [exports.FACET_NAMES.FEATURED_IN]: {
        allowedValues: ALLOWED_FEATURED_IN_VALUES,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Featured In',
        inputType: 'checkbox',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: true,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.COLOR}`]: {
        allowedValues: exports.ALLOWED_COLORS,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        title: 'Color',
        inputType: 'color',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.READY_TO_HANG}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Ready to Hang',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.ALL}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PAINTINGS}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PHOTOGRAPHY}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DRAWINGS}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.PRINTMAKING}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.DIGITAL}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.MIXED_MEDIA}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
    [`${exports.CATEGORY_VALUES_NAMES.COLLAGE}__${exports.FACET_NAMES.FRAME}`]: {
        allowedValues: ALLOWED_BOOLEAN_VALUES,
        onlyNonEmptyResults: false,
        useHardcodedValues: false,
        useProviderValues: false,
        isOpen: true,
        isToggle: true,
        title: 'Framed',
        inputType: 'toggle',
    },
};
